import { Select } from 'entities/Select'
import { useBranchStore } from 'shared/store/branchesSlice'

export const Country = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()

  const updateTown = (value: string | number) => {
    updateBranch({ Country: value as '1' | '2' })
  }

  return (
    <>
      <Select
        key={`country_select_${branchList?.find(branch => branch.Intern === branchId)?.Country}`}
        value={branchList?.find(branch => branch.Intern === branchId)?.Country}
        options={countryList}
        onChange={updateTown}
      />
    </>
  )
}

const countryList = [
  {
    value: '1',
    label: 'Switzerland'
  },
  {
    value: '2',
    label: 'Germany'
  }
]
